// cart-protection.js
// This script intercepts fetch and XMLHttpRequest to protect personalised items and keep them in sync.

(function() {
  window.isAddingPersonalisedItem = false;
  
  // Try to get the personalisation product name from settings if it exists in the DOM, 
  // otherwise fallback to 'Personalisation'. 
  // We will also inject window.personalisationProductName in theme.liquid.
  const getAddonTitle = () => window.personalisationProductName || "Personalisation";

  let addonVariantIds = new Set();
  let addonKeys = new Set();

  const syncCartOrphans = async () => {
      try {
          const cartRes = await fetch(window.Shopify.routes.root + 'cart.js');
          const cartData = await cartRes.json();
          
          addonVariantIds.clear();
          addonKeys.clear();
          
          let needsSync = false;
          let updates = {};
          
          const mainProducts = {};
          const addonTitle = getAddonTitle();
          
          // 1. Map all expected add-on quantities based on main products
          cartData.items.forEach(item => {
              if (item.product_title !== addonTitle && item.properties && item.properties['Personalisation ID']) {
                  const linkId = item.properties['Personalisation ID'];
                  mainProducts[linkId] = (mainProducts[linkId] || 0) + item.quantity;
              }
          });
          
          // 2. Check if add-on products match the expected quantities
          cartData.items.forEach(item => {
              if (item.product_title === addonTitle && item.properties && item.properties['Personalisation ID']) {
                  const linkId = item.properties['Personalisation ID'];
                  const expectedQty = mainProducts[linkId] || 0;
                  
                  addonVariantIds.add(item.variant_id.toString());
                  addonKeys.add(item.key);
                  
                  if (item.quantity !== expectedQty) {
                      updates[item.key] = expectedQty;
                      needsSync = true;
                  }
              }
          });
          
          // 3. If out of sync, apply the fixes
          if (needsSync) {
              console.log('[Cart Protection] Syncing orphaned add-on products...', updates);
              const syncRes = await fetch(window.Shopify.routes.root + 'cart/update.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ updates })
              });
              return await syncRes.json();
          }
          
          return cartData;
      } catch (e) {
          console.error('[Cart Protection] Sync error:', e);
          return null;
      }
  };

  const originalFetch = window.fetch;
  window.fetch = async function(...args) {
      let [resource, config] = args;
      
      // We only care about URLs that modify the cart
      if (typeof resource === 'string' && (resource.includes('/cart/change') || resource.includes('/cart/update') || resource.includes('/cart/clear'))) {
          
          // 1. Block malicious/automated removals during the Add to Cart sequence
          if (window.isAddingPersonalisedItem) {
              console.warn('[Cart Protection] Blocked an automated fetch cart modification by a third-party app!', resource);
              const cartRes = await originalFetch(window.Shopify.routes.root + 'cart.js');
              return new Response(await cartRes.text(), {
                  status: 200,
                  headers: { 'Content-Type': 'application/json' }
              });
          }
          
          // 2. Allow the mutation to happen
          const response = await originalFetch.apply(this, args);
          
          // 3. IMMEDIATELY check if we need to sync orphans (e.g. they removed the main product)
          // To ensure PostCo sees the fully synced cart, we run syncCartOrphans BEFORE returning the response!
          // But only if we can parse the JSON response.
          try {
              const finalCartState = await syncCartOrphans();
              if (finalCartState) {
                  return new Response(JSON.stringify(finalCartState), {
                      status: 200,
                      headers: { 'Content-Type': 'application/json' }
                  });
              }
          } catch(e) {
              console.error(e);
          }
          
          return response;
      }
      return originalFetch.apply(this, args);
  };

  const originalXHROpen = XMLHttpRequest.prototype.open;
  const originalXHRSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function(method, url, async, user, password) {
      this._interceptedUrl = url;
      
      if (url && typeof url === 'string' && (url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear'))) {
          if (window.isAddingPersonalisedItem) {
              console.warn('[Cart Protection] Redirecting automated XHR cart modification to /cart.js', url);
              url = window.Shopify.routes.root + 'cart.js';
              method = 'GET';
          }
      }
      return originalXHROpen.call(this, method, url, async, user, password);
  };

  XMLHttpRequest.prototype.send = function(body) {
      if (this._interceptedUrl && (this._interceptedUrl.includes('/cart/change') || this._interceptedUrl.includes('/cart/update') || this._interceptedUrl.includes('/cart/clear'))) {
          if (window.isAddingPersonalisedItem) {
              body = null; // Do not send body for GET requests
          }
          
          // For XHR, it's harder to intercept the response dynamically like fetch, 
          // so we just run a background sync after the request completes.
          this.addEventListener('load', () => {
              if (!window.isAddingPersonalisedItem) {
                  setTimeout(() => syncCartOrphans(), 500);
              }
          });
      }
      return originalXHRSend.call(this, body);
  };
  
  // Run once on load to populate state and clean up orphans if needed
  syncCartOrphans();

  // UI Cleanup for PostCo Drawer (and others)
  // Safely targets only elements associated with the Add-on Variant ID or Line Item Key
  setInterval(() => {
      if (addonVariantIds.size === 0 && addonKeys.size === 0) return;
      
      const selectors = [];
      addonVariantIds.forEach(vid => {
          selectors.push(`[data-quantity-variant-id="${vid}"]`);
          selectors.push(`[data-variant-id="${vid}"]`);
          selectors.push(`[data-id="${vid}"]`);
          selectors.push(`[data-variant="${vid}"]`);
          selectors.push(`a[href*="variant=${vid}"]`);
      });
      addonKeys.forEach(key => {
          selectors.push(`[data-id="${key}"]`);
          selectors.push(`[data-key="${key}"]`);
          selectors.push(`a[href*="line=${key}"]`);
          selectors.push(`a[href*="id=${key}"]`);
      });
      
      const elements = document.querySelectorAll(selectors.join(', '));
      elements.forEach(el => {
          const isControl = el.tagName === 'INPUT' || el.tagName === 'BUTTON' || (el.tagName === 'A' && (el.href.includes('remove') || el.href.includes('change')));
          
          if (isControl) {
              el.style.setProperty('display', 'none', 'important');
              el.style.setProperty('pointer-events', 'none', 'important');
          } else {
              let container = null;
              
              // 1. Is 'el' itself the container? (e.g. a <li> with data-id)
              const hasControls = el.querySelector('input') || el.querySelector('a[href*="remove"]') || el.querySelector('button');
              const hasMultiple = el.querySelectorAll('input').length > 1 || el.querySelectorAll('a[href*="remove"]').length > 1;
              
              if (hasControls && !hasMultiple) {
                  container = el;
              } else {
                  // 2. Traverse up very strictly
                  let curr = el.parentElement;
                  let depth = 0;
                  while (curr && curr !== document.body && depth < 4) {
                      const className = (curr.className || '').toString().toLowerCase();
                      
                      // It must look exactly like a single item row, and definitely not a list
                      const isItemRow = (className.includes('item') || className.includes('row') || className.includes('line')) 
                                        && !className.includes('items') 
                                        && !className.includes('list')
                                        && !className.includes('rows');
                                        
                      if (isItemRow) {
                          const inputs = curr.querySelectorAll('input');
                          const removes = curr.querySelectorAll('a[href*="remove"], button[aria-label*="emove"], button[class*="remove"]');
                          if (inputs.length <= 1 && removes.length <= 1) {
                              container = curr;
                          }
                          break; // Stop at the first item row boundary
                      }
                      
                      curr = curr.parentElement;
                      depth++;
                  }
              }
              
              if (container) {
                  // Silver Bullet Verification: Ensure this row is strictly for the add-on product
                  const productLinks = Array.from(container.querySelectorAll('a[href*="/products/"]'));
                  let isStrictlyAddon = true; // Assume true unless proven otherwise
                  
                  if (productLinks.length > 0) {
                      const addonTitle = getAddonTitle();
                      // Check if ANY product link belongs to a different product
                      const hasMainProductLink = productLinks.some(link => {
                          let isAddonLink = false;
                          addonVariantIds.forEach(vid => {
                              if (link.href.includes(vid)) isAddonLink = true;
                          });
                          if (link.textContent.includes(addonTitle)) isAddonLink = true;
                          
                          // If it's a product link but NOT an addon link, it's a main product link
                          return !isAddonLink;
                      });
                      
                      if (hasMainProductLink) {
                          isStrictlyAddon = false;
                      }
                  }
                  
                  // If the container holds main product links (e.g. bundled row or traversal went too high), ABORT!
                  if (!isStrictlyAddon) return;
                  
                  const controls = container.querySelectorAll('input, button, a[href*="remove"], a[href*="change"], [class*="quantity"], [class*="qty"], [class*="remove"]');
                  controls.forEach(ctrl => {
                      if (ctrl !== el && !ctrl.contains(el)) { // Don't hide the main product link
                          ctrl.style.setProperty('display', 'none', 'important');
                          ctrl.style.setProperty('pointer-events', 'none', 'important');
                          
                          // Strip borders and backgrounds from any wrappers holding these controls
                          if (ctrl.tagName === 'INPUT' || ctrl.tagName === 'BUTTON' || (ctrl.tagName === 'A' && ctrl.href.includes('remove'))) {
                              let p = ctrl.parentElement;
                              let d = 0;
                              // Traverse up a few levels (but stop at the row container) to kill any wrapper borders
                              while (p && p !== container && d < 3) {
                                  p.style.setProperty('border', 'none', 'important');
                                  p.style.setProperty('background', 'transparent', 'important');
                                  p.style.setProperty('box-shadow', 'none', 'important');
                                  p = p.parentElement;
                                  d++;
                              }
                          }
                      }
                  });
              }
          }
      });
  }, 1000);

})();
